/* eslint-disable */

export const protobufPackage = "od_protos.sell.reception.data";

/**
 * PartnershipReferral contains the partnership referral type and identifier.
 * Next ID: 4
 */
export interface PartnershipReferral {
  type: string;
  identifier: string;
  userId: string;
}

function createBasePartnershipReferral(): PartnershipReferral {
  return { type: "", identifier: "", userId: "" };
}

export const PartnershipReferral = {
  fromJSON(object: any): PartnershipReferral {
    return {
      type: isSet(object.type) ? String(object.type) : "",
      identifier: isSet(object.identifier) ? String(object.identifier) : "",
      userId: isSet(object.userId) ? String(object.userId) : "",
    };
  },

  toJSON(message: PartnershipReferral): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.identifier !== "") {
      obj.identifier = message.identifier;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PartnershipReferral>, I>>(base?: I): PartnershipReferral {
    return PartnershipReferral.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PartnershipReferral>, I>>(object: I): PartnershipReferral {
    const message = createBasePartnershipReferral();
    message.type = object.type ?? "";
    message.identifier = object.identifier ?? "";
    message.userId = object.userId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
